import React from 'react';
import PlantNav from './navs/PlantNav';
import ChangePhoneNumber from './updateProfileComponents/ChangePhoneNumber';

const UpdatePhoneNumber = () => {
    return (
        <div>
            <PlantNav />
            <ChangePhoneNumber />
        </div>
    )
}

export default UpdatePhoneNumber;
